import { AssetStatus, AssetCondition, WorkOrderStatus } from '@/types/models';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const STATUS_CONFIG: Record<AssetStatus, { label: string; className: string }> = {
  received: { label: 'Received', className: 'bg-status-received text-white' },
  triaged: { label: 'Triaged', className: 'bg-status-processing text-white' },
  sanitization_pending: { label: 'Sanitization Pending', className: 'bg-status-testing text-white' },
  sanitized: { label: 'Sanitized', className: 'bg-status-complete text-white' },
  qa_passed: { label: 'QA Passed', className: 'bg-status-complete text-white' },
  inventory: { label: 'Inventory', className: 'bg-status-received text-white' },
  disposition: { label: 'Disposition', className: 'bg-status-processing text-white' },
  shipped: { label: 'Shipped', className: 'bg-status-complete text-white' },
  processing: { label: 'Processing', className: 'bg-status-processing text-white' },
  testing: { label: 'Testing', className: 'bg-status-testing text-white' },
  completed: { label: 'Completed', className: 'bg-status-complete text-white' },
};

const CONDITION_CONFIG: Record<AssetCondition, { label: string; className: string }> = {
  new: { label: 'New', className: 'bg-condition-new text-white' },
  like_new: { label: 'Like New', className: 'bg-condition-like-new text-white' },
  good: { label: 'Good', className: 'bg-condition-good text-white' },
  fair: { label: 'Fair', className: 'bg-condition-fair text-white' },
  poor: { label: 'Poor', className: 'bg-condition-poor text-white' },
  damaged: { label: 'Damaged', className: 'bg-condition-damaged text-white' },
  parts_only: { label: 'Parts Only', className: 'bg-condition-parts text-white' },
  scrap: { label: 'Scrap', className: 'bg-condition-scrap text-white' },
};

export function AssetStatusBadge({ status }: { status: AssetStatus }) {
  const config = STATUS_CONFIG[status];
  return <Badge className={cn('border-0', config.className)}>{config.label}</Badge>;
}

/** @deprecated Use AssetStatusBadge */
export const StatusBadge = AssetStatusBadge;

export function ConditionBadge({ condition }: { condition: AssetCondition }) {
  const config = CONDITION_CONFIG[condition];
  return <Badge className={cn('border-0', config.className)}>{config.label}</Badge>;
}

export function WorkOrderStatusBadge({ status }: { status: WorkOrderStatus | string }) {
  const colors: Record<string, string> = {
    scheduled: 'bg-muted text-muted-foreground',
    in_progress: 'bg-status-processing text-white',
    intake_complete: 'bg-status-received text-white',
    processing: 'bg-status-testing text-white',
    completed: 'bg-status-complete text-white',
    cancelled: 'bg-status-destroyed text-white',
  };
  const label = status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  return <Badge className={cn('border-0', colors[status] || 'bg-muted text-foreground')}>{label}</Badge>;
}

/** @deprecated Use WorkOrderStatusBadge */
export const JobStatusBadge = WorkOrderStatusBadge;
